import { Box, Button, Typography } from "@mui/material";
import styles from "../../screens/MassMailing/MassMailing.module.css";
import { customTextColor } from "../../utils/const";

const SalesRecruiter = ({
  image,
  name,
  emailID,
  status,
  btn2,
  btn2Style,
  handleSelect,
  candidateId,
  recruiter,
}) => {
  const allCandidates = recruiter?.candidates?.flatMap(
    (recruiter) => recruiter?.id
  );

  console.log({ allCandidates });

  return (
    <Box
      className={styles.recruiter_job_post}
      sx={{ border: "1px solid #f5f5f5" }}
    >
      <Box>
        {/* <img src={image} alt="" /> */}
        <span style={{ color: customTextColor }}>
          <Typography>Name: {name}</Typography>
          <Typography>Email ID: {emailID}</Typography>
          <Typography sx={{ margin: "0 !important" }}>
            Matching Candidate in Bench Sales: {status}
          </Typography>
        </span>
      </Box>
      <Box style={{ alignSelf: "flex-end" }}>
        <button onClick={() => handleSelect(candidateId)} style={btn2Style}>
          {btn2}
        </button>
      </Box>
    </Box>
  );
};

export default SalesRecruiter;
